/* Unified WELCOME10 A/B/C/D popup. Native Klaviyo transport stays launch-gated;
 * explicit previews never submit email, identify profiles or emit analytics. */
(function () {
  'use strict';
  var root = document.getElementById('lpl-welcome');
  var configNode = document.getElementById('lpl-welcome-config');
  if (!root || !configNode || root.dataset.initialized === 'true') return;
  var config;
  try { config = JSON.parse(configNode.textContent); } catch (_) { return; }
  if (config.shopId !== '89047695659' || config.themeId !== '192394133803') return;
  var forcedHash = new URLSearchParams(location.hash.slice(1)).get('lpl-popup');
  var forcedPreview = /^[ABCD]$/.test(forcedHash || '');
  var preview = config.preview === true || forcedPreview || !!(window.Shopify && window.Shopify.designMode);
  if (!preview && (config.liveEnabled !== true || config.globalEmailFlowVerified !== true)) return;
  root.dataset.initialized = 'true';
  var dialog = root.querySelector('.lpl-welcome__dialog');
  var title = root.querySelector('#lpl-welcome-title');
  var form = root.querySelector('[data-welcome-form]');
  var email = root.querySelector('[data-welcome-email]');
  var submit = root.querySelector('[data-welcome-submit]');
  var submitLabel = root.querySelector('[data-welcome-submit-label]');
  var spinner = root.querySelector('[data-welcome-spinner]');
  var error = root.querySelector('[data-welcome-error]');
  var status = root.querySelector('[data-welcome-status]');
  var yes = root.querySelector('[data-welcome-yes]');
  var success = root.querySelector('[data-welcome-success]');
  var copyButton = root.querySelector('[data-welcome-copy]');
  var content = root.querySelector('.lpl-welcome__content');
  var gameData = { species: 'both', pet_age: null }, game = null, measured = false;
  var gameLoading = null, gamePreparing = false, openSequence = 0;
  var prefix = preview ? 'lpl_preview_' + config.themeId + '_' : 'lpl_';
  var keys = { done: prefix + 'pop_done', dismissed: prefix + 'pop_dismissed', shown: prefix + 'pop_session', emailSession: prefix + 'pop_email_session' };
  var memory = {}, localEvents = [], arm = '', state = '', busy = false, open = false, complete = false;
  var previousFocus = null, lock = null, openedAt = 0, exposureId = '', submissionId = '';
  var submissionEmail = '';
  var ready = false, identitySuppressed = false, pending = false, observer = null, closeTimer = null, copyTimer = null;
  var previewFailure = false, pageDestroyed = false, acceptedEmail = '';
  var CODE = 'WELCOME10';
  var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  function cookie(name) {
    var part = document.cookie.split(';').map(function (v) { return v.trim(); }).find(function (v) { return v.indexOf(name + '=') === 0; });
    try { return part ? decodeURIComponent(part.slice(name.length + 1)) : (memory[name] || ''); } catch (_) { return ''; }
  }
  function setCookie(name, value, days) {
    memory[name] = value;
    document.cookie = name + '=' + encodeURIComponent(value) + '; Max-Age=' + Math.round(days * 86400) + '; Path=/; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : '');
  }
  function session(name, value) {
    try { if (arguments.length > 1) window.sessionStorage.setItem(name, value); else return window.sessionStorage.getItem(name) || memory[name] || ''; }
    catch (_) { if (arguments.length === 1) return memory[name] || ''; }
    if (arguments.length > 1) memory[name] = value;
  }
  function random() {
    try { var a = new Uint32Array(1); window.crypto.getRandomValues(a); return a[0] / 4294967296; }
    catch (_) { return Math.random(); }
  }
  function uid() { return Date.now().toString(36) + '-' + Math.floor(random() * 4294967296).toString(36); }
  function device() { return window.innerWidth < 768 ? 'mobile' : 'desktop'; }
  function isGame() { return arm === 'C' || arm === 'D'; }
  function assignArm() {
    measured = false;
    if (preview && /^[ABCD]$/.test(forcedHash || '')) { arm = forcedHash; return arm; }
    if (/^[ABCD]$/.test(config.mode || '')) { arm = config.mode; return arm; }
    var assignment = window.LplAB && window.LplAB.popupAssignment ? window.LplAB.popupAssignment(config.experiment) : null;
    var assigned = !!(assignment && /^[ABCD]$/.test(assignment.variant));
    arm = assigned ? assignment.variant : 'A';
    measured = !!(assigned && assignment.measured);
    return arm;
  }
  function excludedPage() {
    var path = location.pathname.replace(/\/$/, '') || '/';
    return /(?:^|\/)cart$/.test(path) || /(?:^|\/)account(?:\/|$)/.test(path) || /(?:^|\/)password$/.test(path) || /(?:^|\/)policies(?:\/|$)/.test(path) || /(?:^|\/)pages\/contact$/.test(path) || ['cart', 'policy', 'password'].indexOf(config.pageType) !== -1 || String(config.pageType).indexOf('customers/') === 0;
  }
  function identifiedCookie() {
    var value = cookie('__kla_id');
    if (!value) return false;
    var attempts = [value];
    try { attempts.push(window.atob(value.replace(/-/g, '+').replace(/_/g, '/'))); } catch (_) {}
    return attempts.some(function (text) {
      try { var object = JSON.parse(text); return Boolean(object && (object.email || object.$email)); } catch (_) { return false; }
    });
  }
  function legacySuppression() {
    // Read earlier popup records without rewriting or extending their lifetime.
    try {
      if (window.localStorage.getItem('lplcp:submitted:v1') === '1') return 'legacy_submitted';
      for (var i = 0, surfaces = ['product', 'editorial']; i < surfaces.length; i++) {
        var until = Number(window.localStorage.getItem('lplcp:dismissed_until:' + surfaces[i] + ':v2'));
        if (Number.isFinite(until) && until > Date.now()) return 'legacy_dismissed';
      }
    } catch (_) {}
    try {
      if (['product', 'editorial'].some(function (surface) { return window.sessionStorage.getItem('lplcp:opened_session:' + surface + ':v2') === '1'; })) return 'legacy_session';
    } catch (_) {}
    return '';
  }
  function suppression() {
    if (excludedPage()) return 'excluded_page';
    if (cookie(keys.done) === '1') return 'submitted';
    if (cookie(keys.dismissed)) return 'dismissed';
    if (session(keys.shown) === '1') return 'session';
    if (session(keys.emailSession) === '1') return 'email_session';
    if (identitySuppressed || identifiedCookie()) return 'identified';
    return legacySuppression();
  }
  function analyticsAllowed() {
    try { var privacy = window.Shopify && window.Shopify.customerPrivacy; return !!privacy && typeof privacy.analyticsProcessingAllowed === 'function' && privacy.analyticsProcessingAllowed() === true; }
    catch (_) { return false; }
  }
  function emit(name, extra) {
    var detail = Object.assign({ experiment: config.experiment, popup_version: config.version, popup_arm: arm, device: device(), page_template: config.pageTemplate || '', page_type: config.pageType || '', step: isGame() && game ? game.step() : state === 'email_step' ? 2 : 1, exposure_id: exposureId, transport: preview ? 'preview' : 'live' }, extra || {});
    if (state === 'success') detail.step = 'success';
    detail.popup_experiment_id = detail.experiment;
    detail.popup_variant_id = detail.popup_arm;
    detail.popup_experiment_version = detail.popup_version;
    if (preview) { localEvents.push(Object.assign({ event: name }, detail)); return; }
    if (!measured || !analyticsAllowed()) return;
    try {
      var layer = window.dataLayer = window.dataLayer || [];
      var send = typeof window.gtag === 'function' ? window.gtag : function () { layer.push(arguments); };
      send('event', name, Object.assign({ send_to: config.analytics.measurementId, transport_type: 'beacon' }, detail));
    } catch (_) {}
  }
  function visible(node) {
    if (!node || node.hidden || node.getClientRects().length === 0) return false;
    var style = window.getComputedStyle(node);
    return style.visibility !== 'hidden' && style.display !== 'none';
  }
  function overlayBlocked() {
    if (document.hidden) return true;
    if (Array.from(document.querySelectorAll('cart-drawer.active,cart-drawer[open],menu-drawer details[open],header details[open],header-menu details[open]')).some(visible)) return true;
    return Array.from(document.querySelectorAll('dialog[open],[aria-modal="true"]')).some(function (node) { return !root.contains(node) && visible(node); });
  }
  function setState(next) {
    state = next; root.dataset.state = next;
    var playing = next === 'game';
    var two = next === 'two_step', done = next === 'success', second = next === 'email_step';
    content.hidden = playing;
    dialog.setAttribute('aria-labelledby', playing ? 'lpl-game-title' : 'lpl-welcome-title');
    root.querySelector('[data-welcome-step-one]').hidden = !two;
    form.hidden = two || done;
    success.hidden = !done;
    root.querySelector('[data-welcome-line]').hidden = next !== 'one_step';
    root.querySelector('[data-welcome-eyebrow]').hidden = !done;
    root.querySelector('[data-welcome-pill]').hidden = done;
    form.querySelector('[data-welcome-dismiss]').hidden = second && !isGame();
    title.textContent = done ? 'Your $10 is ready.' : two ? 'Want $10 off your first order?' : second ? 'Where should we send your $10?' : 'Take $10 off your first order.';
    submitLabel.textContent = second ? 'Send my code' : 'Get my $10 off';
    error.hidden = true; error.textContent = ''; email.removeAttribute('aria-invalid');
    if (open && !playing) (done ? title : two ? yes : email).focus({ preventScroll: true });
    if (done) status.textContent = 'Your $10 is ready.';
    syncViewport();
  }
  function lockBody() {
    if (lock) return;
    lock = { scrollY: window.scrollY, position: document.body.style.position, top: document.body.style.top, left: document.body.style.left, right: document.body.style.right, width: document.body.style.width, overflow: document.body.style.overflow };
    document.body.style.position = 'fixed'; document.body.style.top = '-' + lock.scrollY + 'px'; document.body.style.left = '0'; document.body.style.right = '0'; document.body.style.width = '100%'; document.body.style.overflow = 'hidden';
  }
  function unlockBody() {
    if (!lock) return;
    var previous = lock; lock = null;
    ['position', 'top', 'left', 'right', 'width', 'overflow'].forEach(function (key) { document.body.style[key] = previous[key]; });
    window.scrollTo(0, previous.scrollY);
  }
  function syncViewport() {
    if (!open) return;
    if (device() !== 'mobile') { dialog.style.removeProperty('--game-viewport-height'); dialog.style.top = ''; return; }
    var viewport = window.visualViewport;
    var height = viewport ? viewport.height : window.innerHeight;
    var offset = viewport ? Math.max(0, window.innerHeight - viewport.height - viewport.offsetTop) : 0;
    dialog.style.setProperty('--game-viewport-height', Math.max(200, height) + 'px');
    dialog.style.top = isGame() && viewport ? viewport.offsetTop + 'px' : '';
    dialog.style.setProperty('--welcome-viewport-height', Math.max(200, height - 72) + 'px');
    dialog.style.setProperty('--welcome-keyboard-offset', offset + 'px');
    if (isGame()) {
      if (document.activeElement === email) window.requestAnimationFrame(function () {
        if (!open || content.hidden) return;
        var needed = submit.offsetTop + submit.offsetHeight + 16 - content.clientHeight;
        if (needed > content.scrollTop) content.scrollTop = needed;
      });
      return;
    }
    if (document.activeElement === email) window.requestAnimationFrame(function () {
      if (!open || document.activeElement !== email) return;
      var field = email.getBoundingClientRect(), button = submit.getBoundingClientRect(), bounds = dialog.getBoundingClientRect();
      var bottom = Math.min(bounds.bottom, viewport ? viewport.offsetTop + viewport.height : window.innerHeight);
      if (button.bottom > bottom - 16) dialog.scrollTop += button.bottom - bottom + 16;
      else if (field.top < bounds.top + 16) dialog.scrollTop -= bounds.top + 16 - field.top;
    });
  }
  // Games are non-critical content. Their code, styles and images stay off the
  // initial page path and load only for an eligible C/D opening. One flight is
  // shared by concurrent preview requests; exposure waits for visible content.
  function ensureGame() {
    if (game) return Promise.resolve(game);
    if (gameLoading) return gameLoading;
    var nodes = [];
    function asset(kind, url) {
      return new Promise(function (resolve, reject) {
        if (!url) { reject(new Error('Missing game asset')); return; }
        var node = document.createElement(kind === 'style' ? 'link' : 'script');
        var timer = window.setTimeout(function () { finish(new Error('Game asset timeout')); }, 10000);
        var settled = false;
        function finish(failure) {
          if (settled) return; settled = true; window.clearTimeout(timer);
          node.onload = node.onerror = null;
          if (failure) reject(failure); else resolve();
        }
        if (kind === 'style') { node.rel = 'stylesheet'; node.href = url; }
        else { node.src = url; node.async = true; }
        node.onload = function () { finish(); };
        node.onerror = function () { finish(new Error('Game asset failed')); };
        nodes.push(node); document.head.appendChild(node);
      });
    }
    gameLoading = Promise.all([asset('style', config.gameStyle), asset('script', config.gameScript)]).then(function () {
      if (typeof window.LPLPopupGame !== 'function') throw new Error('Game renderer unavailable');
      game = window.LPLPopupGame(root, config.assets, { event: emit, announce: function (text) { status.textContent = text; }, step: function (next) { root.dataset.gameStep = next; }, capture: function (data) { gameData = data; setState('email_step'); } });
      return game;
    }).catch(function (failure) {
      nodes.forEach(function (node) { node.remove(); }); gameLoading = null;
      throw failure;
    });
    return gameLoading;
  }
  function show(forceArm) {
    if (open || busy || pageDestroyed || config.mode === 'off' || (!preview && complete)) return false;
    if (!forceArm && (suppression() || gamePreparing)) return false;
    if (overlayBlocked()) { pending = true; return false; }
    // Resolve once when eligible to open, after the delay/overlay gates. Consent
    // or the shared assignment API may not be ready when this script initializes.
    // Preserve this choice through game loading, fallback and visible interaction.
    if (forceArm) { arm = forceArm; measured = false; } else if (!arm) assignArm();
    var sequence = ++openSequence;
    if (isGame() && !game) {
      gamePreparing = true;
      ensureGame().then(function () {
        if (sequence !== openSequence || pageDestroyed) return;
        gamePreparing = false; show(forceArm);
      }).catch(function () {
        if (sequence !== openSequence || pageDestroyed) return;
        gamePreparing = false; measured = false;
        emit('popup_error', { error_type: 'game_assets' });
        // Keep the offer usable after an asset failure, without measuring the
        // fallback control as an assigned A exposure.
        arm = 'A'; show(forceArm ? 'A' : undefined);
      });
      return true;
    }
    gamePreparing = false;
    window.clearTimeout(closeTimer); previousFocus = document.activeElement;
    root.hidden = false; root.setAttribute('aria-hidden', 'false'); open = true; pending = false;
    openedAt = Date.now(); exposureId = uid(); submissionId = ''; acceptedEmail = '';
    lockBody(); gameData = { species: 'both', pet_age: null };
    if (game) game.stop();
    if (isGame()) { setState('game'); game.start(arm); } else setState(arm === 'B' ? 'two_step' : 'one_step');
    session(keys.shown, '1');
    window.requestAnimationFrame(function () {
      if (!open) return; root.classList.add('is-open');
      if (measured && window.LplAB && window.LplAB.popupExposure) { var record = window.LplAB.popupExposure(config.experiment, root, { arm_name: {A:'one_step',B:'two_step',C:'cards',D:'human_years'}[arm], page_context:config.pageType }); if (record) exposureId = record.exposure; else measured = false; }
      emit('popup_view');
    });
    return true;
  }
  function attempt() {
    if (!ready || open || pageDestroyed) return;
    if (suppression()) { pending = false; return; }
    show();
  }
  function dismiss(method, suppressCookie, track) {
    if (!open) return;
    if (track !== false) emit('popup_dismiss', { method: method });
    if (suppressCookie !== false && !complete) setCookie(keys.dismissed, '1', 14);
    open = false; pending = false; root.classList.remove('is-open');
    if (isGame()) root.hidden = true;
    if (game) game.stop(); content.hidden = false;
    root.setAttribute('aria-hidden', 'true');
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    closeTimer = window.setTimeout(function () { if (!open) root.hidden = true; }, reduced ? 0 : 320);
    unlockBody();
    if (previousFocus && previousFocus.isConnected && typeof previousFocus.focus === 'function') previousFocus.focus({ preventScroll: true });
  }
  function focusables() { return Array.from(dialog.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),[tabindex="0"]')).filter(visible); }
  function keydown(event) {
    if (!open) return;
    if (event.key === 'Escape') { event.preventDefault(); dismiss('esc'); return; }
    if (event.key !== 'Tab') return;
    var nodes = focusables(), first = nodes[0], last = nodes[nodes.length - 1];
    if (!first) { event.preventDefault(); dialog.focus(); return; }
    if (event.shiftKey && (document.activeElement === first || !nodes.includes(document.activeElement))) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && (document.activeElement === last || !nodes.includes(document.activeElement))) { event.preventDefault(); first.focus(); }
  }
  function setBusy(value) {
    busy = value; submit.disabled = value; email.readOnly = value; spinner.hidden = !value;
    submit.setAttribute('aria-busy', value ? 'true' : 'false');
    submitLabel.textContent = value ? 'Sending your code…' : state === 'email_step' ? 'Send my code' : 'Get my $10 off';
  }
  function showError(text) { error.textContent = text; error.hidden = false; email.setAttribute('aria-invalid', 'true'); status.textContent = text; }
  function properties() {
    var props = { product_lane: 'global', product_interest: 'global', species: gameData.species || 'both', discount_code: CODE, popup_version: 'global_welcome10_v1', experiment: config.experiment, popup_experiment_id: config.experiment, popup_experiment_version: config.version, popup_variant_id: arm, popup_arm: arm, popup_measured: measured, device: device(), page_template: config.pageTemplate || '', context_id: 'global_welcome10_v1', capture_destination: 'global', source_path: location.pathname, source_url: location.origin + location.pathname, 'LPL Landing Page': location.pathname, exposure_id: exposureId };
    if (Number.isInteger(gameData.pet_age) && gameData.pet_age > 0) props.pet_age = gameData.pet_age;
    return props;
  }
  async function request(endpoint, payload) {
    if (preview || config.liveEnabled !== true || config.globalEmailFlowVerified !== true) throw new Error('Live transport is not enabled');
    var controller = new AbortController(), timer = window.setTimeout(function () { controller.abort(); }, 12000);
    try {
      var response = await window.fetch('https://a.klaviyo.com/client/' + endpoint + '/?company_id=' + encodeURIComponent(config.klaviyo.publicSiteId), { method: 'POST', headers: { accept: 'application/vnd.api+json', 'content-type': 'application/vnd.api+json', revision: config.klaviyo.revision }, signal: controller.signal, body: JSON.stringify(payload) });
      if (!response.ok) throw new Error('Capture was not accepted');
    } finally { window.clearTimeout(timer); }
  }
  async function send(value) {
    if (preview) { if (previewFailure) { previewFailure = false; throw new Error('Preview failure'); } return; }
    // User approved worldwide welcome-code delivery. An accepted form submission
    // follows the same consented subscription and exact-code event route everywhere.
    var props = properties();
    if (acceptedEmail !== value) {
      await request('subscriptions', { data: { type: 'subscription', attributes: { custom_source: 'LPL Global WELCOME10 Popup', profile: { data: { type: 'profile', attributes: { email: value, properties: props, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } }, relationships: { list: { data: { type: 'list', id: config.klaviyo.listId } } } } });
      acceptedEmail = value;
    }
    await request('events', { data: { type: 'event', attributes: { properties: props, unique_id: submissionId, metric: { data: { type: 'metric', attributes: { name: config.klaviyo.metric } } }, profile: { data: { type: 'profile', attributes: { email: value, properties: props } } } } } });
  }
  async function onSubmit(event) {
    event.preventDefault();
    if (busy || complete) return;
    var value = email.value.trim();
    if (!emailPattern.test(value)) { showError('Enter an email address we can send the code to.'); emit('popup_error', { error_type: 'invalid_email' }); email.focus(); return; }
    error.hidden = true; error.textContent = ''; email.removeAttribute('aria-invalid'); status.textContent = '';
    if (!submissionId || submissionEmail !== value) { submissionId = 'lpl-global-' + uid(); submissionEmail = value; }
    setBusy(true);
    var result;
    await Promise.all([send(value).then(function () { result = null; }, function (failure) { result = failure; }), new Promise(function (resolve) { window.setTimeout(resolve, 600); })]);
    setBusy(false);
    if (result) { showError('Something went wrong. Try again.'); emit('popup_error', { error_type: 'api_failure' }); return; }
    complete = true; setCookie(keys.done, '1', 365);
    emit('popup_submit', { time_to_submit_ms: Math.max(0, Date.now() - openedAt) });
    setState('success'); emit('popup_success');
  }
  async function copyCode() {
    var copied = false;
    try { if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') { await navigator.clipboard.writeText(CODE); copied = true; } } catch (_) {}
    if (!copied) {
      try { var range = document.createRange(); range.selectNodeContents(root.querySelector('[data-welcome-code]')); var selection = window.getSelection(); selection.removeAllRanges(); selection.addRange(range); } catch (_) {}
      return false;
    }
    copyButton.textContent = 'Copied'; status.textContent = 'Copied'; emit('popup_copy_code');
    window.clearTimeout(copyTimer); copyTimer = window.setTimeout(function () { copyButton.textContent = 'Copy'; }, 2000);
    return true;
  }
  function queryIdentity() {
    if (preview) return;
    function identified(value) { if (value === true) { identitySuppressed = true; pending = false; if (open && !busy && !complete) dismiss('close', false, false); } }
    try {
      if (window.klaviyo && typeof window.klaviyo.isIdentified === 'function') Promise.resolve(window.klaviyo.isIdentified()).then(identified).catch(function () {});
      else { window._klOnsite = window._klOnsite || []; window._klOnsite.push(['isIdentified', identified]); }
    } catch (_) {}
  }
  root.querySelector('[data-welcome-close]').addEventListener('click', function () { dismiss('close'); });
  root.querySelectorAll('[data-welcome-dismiss]').forEach(function (node) { node.addEventListener('click', function () { dismiss('no_thanks'); }); });
  root.querySelector('[data-welcome-scrim]').addEventListener('click', function () { dismiss('scrim'); });
  yes.addEventListener('click', function () { if (!open || busy || state !== 'two_step') return; emit('popup_step1_yes'); setState('email_step'); });
  form.addEventListener('submit', onSubmit);
  email.addEventListener('focus', syncViewport);
  copyButton.addEventListener('click', copyCode);
  root.querySelector('[data-welcome-shop]').addEventListener('click', async function (event) {
    event.preventDefault(); var copied = await copyCode(); emit('popup_shop_click', { copied: copied });
    location.assign('/pages/find-their-system');
  });
  document.addEventListener('keydown', keydown);
  document.addEventListener('focusin', function (event) { if (open && !root.contains(event.target)) { if (state === 'game' && game) game.focus(); else (state === 'success' ? title : state === 'two_step' ? yes : email).focus({ preventScroll: true }); } });
  document.addEventListener('visibilitychange', function () { if (pending) attempt(); });
  window.addEventListener('resize', syncViewport);
  if (window.visualViewport) { window.visualViewport.addEventListener('resize', syncViewport); window.visualViewport.addEventListener('scroll', syncViewport); }
  window.addEventListener('pagehide', function () { pageDestroyed = true; if (observer) observer.disconnect(); if (game) game.stop(); unlockBody(); });
  var params = new URLSearchParams(location.search);
  if (params.has('_kx') || (params.get('utm_medium') || '').toLowerCase() === 'email') session(keys.emailSession, '1');
  if (!suppression()) queryIdentity();
  observer = new MutationObserver(function () { if (pending && !open) attempt(); });
  observer.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open', 'class', 'hidden', 'aria-hidden', 'aria-expanded'], childList: true });
  function startTimer() {
    window.setTimeout(function () { ready = true; attempt(); }, Number(config.delayMs || 12000));
  }
  if (document.readyState === 'complete') startTimer(); else window.addEventListener('load', startTimer, { once: true });
  if (preview) window.LPLWelcomePopupPreview = {
    events: localEvents,
    open: function (selectedArm) { if (selectedArm === 'one_step') selectedArm = 'A'; else if (selectedArm === 'two_step') selectedArm = 'B'; if (!/^[ABCD]$/.test(selectedArm)) throw new Error('Unknown preview arm'); if (open) dismiss('close', false); complete = false; email.value = ''; return show(selectedArm); },
    failNextSubmit: function () { previewFailure = true; },
    reset: function () { [keys.done, keys.dismissed].forEach(function (key) { setCookie(key, '', -1); delete memory[key]; }); [keys.shown, keys.emailSession].forEach(function (key) { session(key, ''); }); },
    state: function () { return { arm: arm, step: state, open: open, busy: busy, complete: complete, transport: 'preview', gameStep: game && game.step(), captureProperties: properties() }; }
  };
  if (preview && /^[ABCD]$/.test(forcedHash || '')) window.setTimeout(function () { window.LPLWelcomePopupPreview.open(forcedHash); }, 100);
})();
